import { actionTypes } from '../actions/actionTypes/loginActionTypes';

// ✅ 1. Isolated utility — not duplicated across files
// src/utils/sessionUtils.js
export const clearExpiredSession = () => {
  try {
    const expiryTime = localStorage.getItem('sessionExpiry');
    if (expiryTime && Date.now() > Number(expiryTime)) {
      localStorage.clear();
      sessionStorage.clear();
      return true;
    }
    return false;
  } catch (e) {
    // ✅ 2. localStorage can throw in private browsing / restricted environments
    console.warn('Session check failed:', e);
    return false;
  }
};
clearExpiredSession();
let initialState = {
  isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
  isInitChecked: false,
  loginLoader: false,
  uplaodedFileScanLoader: false,
  ResetPWDData: {},
  resetPWDLoader: false,
  ProfilePicURL: '',
  ProfilePicURLLoader: false,
  isProfilePicExist: false,
};

/**
 * Redux reducers.
 * Used to update state in the store after actions are issued.
 */
export function loggedIn(state = initialState, action) {
  switch (action.type) {
    case actionTypes.IsLoggedIn:
      return {
        ...state,
        isLoggedIn: action.loggedInFlag,
        isInitChecked: true,
        loginLoader: false,
        uplaodedFileScanLoader: false,
      };
    case 'loginLoader':
      return {
        ...state,
        loginLoader: true,
        authType: action.authType,
      };

    case 'uplaodedFileScanLoader':
      return {
        ...state,
        uplaodedFileScanLoader: action.isLoading,
      };

    case actionTypes.RESET_PASSWORD_GET_OTP_SUCCESS:
      return {
        ...state,
        resetPWDLoader: false,
        ResetPWDData: action?.data,
      };

    case actionTypes.RESET_PASSWORD_GET_OTP_FAILURE:
      return {
        ...state,
        resetPWDLoader: false,
        ResetPWDData: {},
      };

    case actionTypes.RESET_PASSWORD_LOADER:
      return {
        ...state,
        resetPWDLoader: true,
      };

    case actionTypes.CLEAR_PWD_DATA:
      return {
        ...state,
        PWDData: {},
      };

    case 'PROFILE_PIC_SUCCESS':
      return {
        ...state,
        ProfilePicURLLoader: false,
        ProfilePicURL: action.data.url,
        isProfilePicExist: action.data.isSuccess,
      };

    case 'PROFILE_PIC_FAILURE':
      return {
        ...state,
        ProfilePicURLLoader: false,
        ProfilePicURL: '',
      };

    case 'PROFILEPIC_LOADER':
      return {
        ...state,
        ProfilePicURLLoader: true,
      };

    default:
      return state;
  }
}
